import { Component, OnInit, ChangeDetectionStrategy, Input, OnChanges, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { TableConfig } from 'src/app/core/models/table-config.model';
import * as moment from 'moment-jalaali';

@Component({
  selector: 'bt-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableComponent implements OnInit, OnChanges {
  @Input() configsTable: TableConfig;
  @Input() data: any[];
  @Input() pageNumber: number;
  @Input() postPage = false;

  @Output() opetarionClick = new EventEmitter<{ element: any, key: string }>();
  @Output() pageSelected = new EventEmitter<number>();

  displayedColumns: string[];

  coutOfPage: number;
  dataSource: any[];

  constructor(
    private changeDetectorRef: ChangeDetectorRef,

  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.setConfigTable();
    this.setDataSource();
    this.setPaginatorConfig();
    this.changeDetectorRef.detectChanges();
  }
  setDataSource() {

    if (this.configsTable.paginator.client) {
      this.dataSource = this.data.slice(0, 10);
    } else {
      this.dataSource = this.data;
    }
  }
  setPaginatorConfig() {
    if (this.configsTable.paginator.client) {
      const page = Math.ceil(this.data.length / this.configsTable.paginator.itemPerPage);
      this.coutOfPage = page;
    } else {
      this.coutOfPage = this.pageNumber;
    }
  }
  async setConfigTable() {
    this.displayedColumns = this.configsTable ? this.configsTable.row.map(res => res.columnDef) : [];
    if (this.configsTable.operaions.length) {
      this.displayedColumns.push('operation');
    }
    if (this.configsTable.footer.length && this.data) {
      await Promise.all(this.configsTable.footer.map(res => {
        res.sum = this.data.map(t => t[res.sumColumn]).reduce((acc, value) => acc + value, 0);
      }));
    }
  }
  opetarionClickMethod(element, key) {
    this.opetarionClick.emit({ element, key });
  }
  pageSelectedChange(event) {
    if (this.configsTable.paginator.client) {
      this.dataSource = this.data.slice(
        (event - 1) * this.configsTable.paginator.itemPerPage,
        (event) * this.configsTable.paginator.itemPerPage
      );

    } else {
      this.pageSelected.emit(event);
    }
  }
  checkExpiring(element) {
    if (element.hasOwnProperty('dueDate') && this.postPage) {

      const dayDiff = moment(element.dueDate).diff(moment(new Date()), 'days') + 1;
      if (dayDiff < 15) {
        return true;
      }
      return false;
    }
    return false;
  }

  checkPending(element) {
    if (element.status && element.status === 3 && this.postPage) {
      return true;
    }
    return false;
  }

}



